import { useCallback, useContext } from 'react'

import { setServicePrices, apiServicesFetchAllStart, apiServicesFetchAllSuccess, apiServicesFetchAllFailure } from '../actions/services'
import { setServices } from '../actions/booking'
import { context } from '../context'
import { settings, LARGE_CAR_SERVICE, SAME_DAY_SERVICE, CONGESTION_ZONE_SERVICE } from '../constants'
import { servicesAdapter, defaultBaseService } from '../adapters'

// One request at a time. On a cold load of a booking URL, startup and the
// mounted step (useLivePrice, the catalogue, the wash grid) each ask for the
// list before it has arrived, and every answer resets the selection to the
// default wash. The second reset wiped the add-on a ?extra= link had just
// ticked. A caller that asks while a request is out gets that request's answer.
let inFlight = false

export const useServicesApi = () => {
  const { dispatch } = useContext(context)

  const apiServicesFetchAll = useCallback(() => {
    if (inFlight) return
    inFlight = true
    dispatch(apiServicesFetchAllStart())
    fetch(`${settings.host}/api/v2/services`)
      .then(response => {
        if (response.ok) return response.json()
        else throw new Error(`apiServicesFetchAll status: ${response.statusText}`)
      })
      .then((json = {}) => {
        const { status, data: apiServices } = json

        if (status !== 'ok') throw new Error(`json: ${JSON.stringify(json)}`)

        dispatch(apiServicesFetchAllSuccess())
        const services = servicesAdapter(apiServices)
        dispatch(setServicePrices(services))

        const firstBaseService = defaultBaseService(services)
        const largeCarService = services.find(service => service.name === 'Extra for large car')
        const sameDayService = services.find(service => service.name === 'Extra for same day')
        const congestionZoneService = services.find(service => service.name === 'Congestion zone premium')
        largeCarService && Object.assign(LARGE_CAR_SERVICE, largeCarService)
        sameDayService && Object.assign(SAME_DAY_SERVICE, sameDayService)
        congestionZoneService && Object.assign(CONGESTION_ZONE_SERVICE, congestionZoneService)

        const selectedServices = {
          ...services.reduce((acc, service) => ({ ...acc, [service.id]: false }), {}),
          [firstBaseService.id]: true,
          [largeCarService.id]: null
        }

        const servicesAvailability = services.reduce((acc, service) => ({ ...acc, [service.id]: !firstBaseService.includes.includes(service.id) }), {})

        dispatch(setServices({ services: selectedServices, servicesAvailability }))
      })
      .catch(error => dispatch(apiServicesFetchAllFailure(`apiServicesFetchAll error: ${JSON.stringify(error)}`)))
      .finally(() => { inFlight = false })
  }, [dispatch])

  return {
    apiServicesFetchAll
  }
}
